import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const DEPO_COUNTRY_DOMAIN = "DCTRY"

export type Country = {
    //isocode: string,
    ctry: string
}

const prepareCountries  = ( response : Country[]   ) => {
    const opts: OptionCl[] = response.map( (ctry : Country) => ({
        id : ctry.ctry,
        description: ctry.ctry
    })
    )
    return opts;
}


// countries for the depository dropdown
export const fetchDepoCountries = (
    dispatch : Dispatch<any>,
    componentType: "DepositoryCriteria"
) => {
    //console.log("ismag criteria service getting data from /countries")
    api
        .post("/codelist/v1/Depository/depcountries")
        .then( (response:AxiosResponse) => {
            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("country domain service: got data " + JSON.stringify(response))
                const countries : Country[] = response.data.Depository; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCountries(countries), domain: DEPO_COUNTRY_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
